import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface PublicRouteProps {
  children: React.ReactNode;
}

/**
 * PublicRoute component for pages that should only be accessible to non-authenticated users.
 * If a user is already authenticated, they will be redirected to the member dashboard.
 * This is useful for login and register pages.
 */
const PublicRoute = ({ children }: PublicRouteProps) => {
  const { isAuthenticated, isLoading, isInitializing } = useAuth();
  const currentPath = window.location.pathname;

  // Allow authenticated users to access /verify-email page
  // This is needed for new users who just registered and need to verify their email
  if (isAuthenticated && currentPath === '/verify-email') {
    return <>{children}</>;
  }

  // Show loading while AuthContext is initializing (fetching user)
  // This prevents race conditions where login page briefly shows before auth is confirmed
  if (isLoading || isInitializing) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '50vh',
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/member" replace />;
  }

  return <>{children}</>;
};

export default PublicRoute;
